import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import '@/assets/css/reset.css'
import '@/assets/icon-aws/css/font-awesome.css'
import ElementUI from 'element-ui'
import { Anchor, BackTop } from 'ant-design-vue'
// import '@/assets/css/common.css'; // 公共样式
import 'element-ui/lib/theme-chalk/index.css' // ele公共样式
// import 'ant-design-vue/dist/antd.css'; // antd
import '@/assets/css/huya.css'
import '@/assets/css/common.css'
import '@/assets/css/paybox.css'
import '@/utils/moment.js'
import VueCookies from 'vue-cookies'
import configListener from '@/utils/configListener'

Vue.config.productionTip = false

router.beforeEach(function(to, from, next) {
  document.title = to.meta.title || '配置后台_小虎弟场控'
  next()
})

Vue.use(VueCookies)
// Vue.use(Anchor);
// Vue.use(BackTop);
Vue.use(ElementUI) // 挂载element-ui库

Vue.prototype.$configListen = new configListener()

// Vue.component(Anchor);
const vm = new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app')

window.vm = vm
